import apiService from "../../api/api.service";
import { CategoriesResponse } from "./categories.types";

export const fetchCategories = async (): Promise<CategoriesResponse> => {
  return apiService.get<CategoriesResponse>("/home/categories");
};
